import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, first, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { Estado, Municipio } from "../../simples";

export interface Props extends kea.FormEditProps<number | null, number | null | undefined> {
}
interface State {
    idEstado?: number | null;
}
const municipios = observeResource(resources.Municipio.query);
const estados = observeResource(resources.Estado.query);

/**Selector de un idMunicipio que tambien muestra un selector de estados como filtro */
export class EstadoMunicipio extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    todosMunicipios = () => municipios;
    estados = () => estados;

    idEstadoFromState = (state: State, props: Props) => state.idEstado;
    idMunicipio = (state: State, props: Props) => props.value;

    municipio = createSelectorRx(this.todosMunicipios, this.idMunicipio, (municipios, idMun) => nullsafe(idMun, idMun => first(municipios, x => x.IdRegistro == idMun)));
    idEstadoFromValue = createSelectorRx(this.municipio, x => nullsafe(x, x => x.IdEstado));
    idEstado = createSelectorRx(this.idEstadoFromValue, this.idEstadoFromState, (val, state) => val === null ? null : (state || val));
    municipios = createSelectorRx(this.todosMunicipios, this.idEstado, (muns, idEstado) => muns.filter(x => x.IdEstado == idEstado));
    handleOnEstado = (x: number) => {
        this.setState({ idEstado: x });
        this.props.onChange && this.props.onChange(undefined);
    }
    handleOnMunicipio = (x: number) => this.props.onChange && this.props.onChange(x);

    render() {
        return (
            <div style={{ display: "flex" }}>
                <div style={{ flex: "1 0 auto" }}>
                    <Estado value={this.idEstado(this.state, this.props)} onChange={this.handleOnEstado} />
                </div>
                <div style={{ flex: "1 0 auto" }}>
                    <Municipio value={this.idMunicipio(this.state, this.props)} onChange={this.handleOnMunicipio} items={this.municipios(this.state, this.props)} />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/selectores/items/estadomunicipio/index.tsx